"use client";

import { LanguageModal } from "@/features/common/user";
import { Button } from "@cronika/ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const localeToCode: Record<string, string> = {
  en: "EN",
  ru: "RU",
  kk: "KZ",
  bn: "BN",
  id: "ID",
  pt: "PT",
  es: "ES",
};

const GlobeIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M2 12h20" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </svg>
);

export const LocaleSwitcher = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { i18n } = useTranslation();

  const currentLocale = i18n.language || "en";
  const localeCode = localeToCode[currentLocale] || currentLocale.toUpperCase();

  return (
    <>
      <Button
        variant="ghost"
        size="lg"
        className="h-12 px-3 gap-2 bg-transparent text-white/40 hover:text-white/60 hover:bg-transparent"
        aria-label="Language selector"
        onClick={() => setIsOpen(true)}
      >
        <GlobeIcon />
        <span className="text-sm font-medium">{localeCode}</span>
      </Button>
      <LanguageModal open={isOpen} setOpen={setIsOpen} />
    </>
  );
};
